import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { PNotifyService } from '../../../services/pnotify.service';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-responsible-datatable',
  templateUrl: './responsible-datatable.component.html',
  styleUrls: ['./responsible-datatable.component.css']
})
export class ResponsibleDatatableComponent implements OnInit, OnDestroy {

  filter = {
    clientId: '',
    schoolId: ''
  };
  staticFilter = {
    clientId: '',
    schoolId: ''
  };

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};
  responsibles: any[];
  clients: any[];
  schools: any[];
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  pnotify = undefined;

  constructor(
    private http: HttpClient,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    this.pnotify = pnotifyService.getPNotify();

    this.http.get(
      '/api/client/lookup'
    ).subscribe((clients: any[]) => {
      this.clients = clients;
      const array1 = [{ id: '', text: 'Choisir un client' }];
      const array2 = this.clients.map(function (client, index) {
        return { id: client.id, text: client.name };
      });
      this.clientsData = array1.concat(array2);
    });
  }

  ngOnInit() {

    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/responsible',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.responsibles = resp.data;
          const dta = [];
          this.responsibles.forEach(responsible => {
            dta.push({
              id: responsible.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${responsible.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              name: responsible.name,
              username: responsible.username,
              schoolName: responsible.School.name,
              isDemo: responsible.isDemo ? 'Oui' : 'Non',
              expiration: responsible.isDemo ? moment(responsible.expiration).format('DD/MM/YYYY') : '--',
              isActive: responsible.isDemo ? '--' : (responsible.isActive ? 'Oui' : 'Non'),
              actions: `
                <a class="btn btnAction btnNavigate" data-url="/responsible/view/${responsible.id}">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                </a>
                <a class="btn btnAction btnNavigate" data-url="/responsible/edit/${responsible.id}">
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                </a>
                <button class="btn btnAction btnDelete" data-responsible-id="${responsible.id}">
                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                </button>
              `
            });
          });
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'responsible_' + aData.id);
      },
      columns: [
        { data: 'checkbox' },
        { data: 'name' },
        { data: 'username' },
        { data: 'schoolName' },
        { data: 'isDemo' },
        { data: 'expiration' },
        { data: 'isActive' },
        { data: 'actions' },
      ],
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('responsibleId'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url'));
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());
    $('table').on('draw.dt', (event) => this.onCheckChange());
  }
  clientChanged(e: any) {
    this.filter.clientId = e.value;
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map(function (school, index) {
        return { id: school.id, text: school.name };
      });
      this.schoolsData = array1.concat(array2);
    });
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
  }
  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/responsible/' + id)
      .subscribe(
        result => {
          document.getElementById('responsible_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onFilter(): void {
    this.staticFilter = this.filter;
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/responsible/responsible-datatable/responsible-datatable.component.ts